import { Grid } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FormDateInput } from '~/components/FormComponents/FormDateInput.tsx';

interface IInformationBlockFormProps {
  baseName?: string;
  disabled?: boolean;
}

export const InformationBlockForm = ({ baseName = '', disabled }: IInformationBlockFormProps) => {
  const getFieldName = (field: string) => (baseName ? `${baseName}.${field}` : field);

  return (
    <>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormInput
          fullWidth
          disabled={disabled}
          name={getFieldName('lastName')}
          label="Прізвище"
          placeholder="Введіть прізвище"
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormInput
          fullWidth
          disabled={disabled}
          name={getFieldName('firstName')}
          label="Ім'я"
          placeholder="Введіть ім'я"
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormInput
          fullWidth
          disabled={disabled}
          name={getFieldName('middleName')}
          label="По батькові (за наявності)"
          placeholder="Введіть по батькові"
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormDateInput
          name={getFieldName('birthDate')}
          disabled={disabled}
          label="Дата народження"
          isCurrentMaxDate
          placeholder="Введіть дату народження"
        />
      </Grid>
    </>
  );
};
